/* Destilo — consentimientos obligatorios en el carrito.
   - Bloquea el botón de checkout y los botones de pago rápido hasta que se marca
     la casilla obligatoria (edad + Política de Venta + Privacidad).
   - NUNCA premarca ni recuerda el estado entre recargas: cada compra exige una
     aceptación activa (requisito legal "no premarcado").
   - Sella la fecha/hora de aceptación en un atributo del pedido.
   - Mantiene sincronizadas las instancias de página y drawer, y tras re-render. */
(function () {
  /* Sube desde el checkbox hasta el ancestro que contiene el botón de checkout. */
  function scopeOf(cb) {
    var p = cb.parentElement;
    while (p) {
      if (p.querySelector && p.querySelector('button[name="checkout"]')) return p;
      p = p.parentElement;
    }
    return cb.parentElement;
  }

  function apply(cb) {
    var scope = scopeOf(cb);
    if (!scope) return;
    var ok = cb.checked;
    var btn = scope.querySelector('button[name="checkout"]');
    var dyn = scope.querySelector('.cart__dynamic-checkout-buttons');
    if (btn) {
      btn.disabled = !ok;
      btn.setAttribute('aria-disabled', String(!ok));
    }
    if (dyn) {
      dyn.style.opacity = ok ? '' : '0.45';
      dyn.style.pointerEvents = ok ? '' : 'none';
      dyn.setAttribute('aria-hidden', String(!ok));
    }
  }

  /* Escribe (o limpia) el sello de fecha/hora de aceptación en todas las instancias. */
  function stampTime(checked) {
    var stamp = checked ? new Date().toISOString() : '';
    document.querySelectorAll('[data-consent-time]').forEach(function (i) {
      i.value = stamp;
    });
  }

  function syncRequired() {
    document.querySelectorAll('[data-age-confirm]').forEach(apply);
  }

  /* Consentimiento comercial → Klaviyo (misma lógica que los newsletter).
     Solo si tenemos email (cliente logueado): en el carrito el invitado aún no
     ha facilitado email; su consentimiento queda como atributo del pedido y su
     alta se gestiona en el checkout/pedido. Se envía una sola vez por email. */
  var marketingDone = false;
  function subscribeMarketing() {
    if (marketingDone) return;
    var host = document.querySelector('[data-consent][data-customer-email]');
    var email = host && host.getAttribute('data-customer-email');
    if (!email) return;
    if (typeof window.destiloKlaviyoSubscribe === 'function') {
      window.destiloKlaviyoSubscribe(email, 'Carrito · Consentimiento comercial');
      marketingDone = true;
    }
  }

  /* Cambio en una casilla: refleja el mismo estado en las demás instancias
     (drawer + página conviven en la página de carrito). */
  document.addEventListener('change', function (e) {
    var cb = e.target;
    if (!cb || !cb.matches) return;

    if (cb.matches('[data-age-confirm]')) {
      stampTime(cb.checked);
      document.querySelectorAll('[data-age-confirm]').forEach(function (other) {
        if (other !== cb) other.checked = cb.checked;
        apply(other);
      });
    } else if (cb.matches('[data-consent-optional]')) {
      document.querySelectorAll('[data-consent-optional]').forEach(function (other) {
        if (other !== cb) other.checked = cb.checked;
      });
      if (cb.checked) subscribeMarketing();
    }
  });

  /* Red de seguridad: si el botón sigue activo, bloquea el click sin casilla. */
  document.addEventListener(
    'click',
    function (e) {
      var btn = e.target.closest && e.target.closest('button[name="checkout"]');
      if (!btn) return;
      var scope = btn.closest('form') || document;
      var cb = scope.querySelector('[data-age-confirm]') || document.querySelector('[data-age-confirm]');
      if (cb && !cb.checked) {
        e.preventDefault();
        e.stopPropagation();
        var row = cb.closest('.consent__row');
        if (row) {
          row.classList.remove('consent__row--shake');
          void row.offsetWidth;
          row.classList.add('consent__row--shake');
        }
      } else if (cb && cb.checked) {
        /* Refresca el sello justo antes de enviar, por si estuvo marcada un rato. */
        stampTime(true);
      }
    },
    true
  );

  function init() {
    syncRequired();
    var targets = document.querySelectorAll(
      'cart-drawer, #main-cart-footer, .cart__footer, cart-items, #main-cart-items, .cart__contents'
    );
    if (targets.length && 'MutationObserver' in window) {
      var mo = new MutationObserver(function () { syncRequired(); });
      targets.forEach(function (t) { mo.observe(t, { childList: true, subtree: true }); });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
